import { getRequest } from '../utils'

export const getRunningTasks: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['getRunningTasks', projectGuid],
  request: async (projectGuid: string): Promise<RunningTask[]> => {
    const { data } = await getRequest<RunningTask[]>({
      url: `/projects/${projectGuid}/running-tasks`,
    })

    return data || []
  },
}
